import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAudio: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAudio"><Path d="M10.5 18.5C10.5 20.1569 8.933 21.5 7 21.5C5.067 21.5 3.5 20.1569 3.5 18.5C3.5 16.8431 5.067 15.5 7 15.5C8.933 15.5 10.5 16.8431 10.5 18.5ZM10.5 18.5V6L20.5 2.5V15.5M20.5 15.5C20.5 17.1569 18.933 18.5 17 18.5C15.067 18.5 13.5 17.1569 13.5 15.5C13.5 13.8431 15.067 12.5 17 12.5C18.933 12.5 20.5 13.8431 20.5 15.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAudio;
